import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LEGACY_ROUTES, ROUTES } from '@/constants/app/routes';
import { selectUnsavedChanges } from '@/store/selectors';
import { blockNavigation } from '@/store/reducers';

interface INavOptions {
  skipUnsavedChangesGuard?: boolean;
}

export const useNav = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hasUnsavedChanges } = useSelector(selectUnsavedChanges);

  const nav = useCallback(
    async (path: string, options?: INavOptions) => {
      if (hasUnsavedChanges && !options?.skipUnsavedChangesGuard) {
        dispatch(blockNavigation(path));
        return;
      }
      const basePath = new URL(path, window.location.origin).pathname;
      const isAppRoute = (Object.values(ROUTES) as string[]).includes(basePath);
      if (!isAppRoute && Object.values(LEGACY_ROUTES).includes(basePath)) {
        window.location.href = path;
        return;
      }
      navigate(path);
    },
    [navigate, dispatch, hasUnsavedChanges]
  );

  const navLegacy = useCallback((path: string) => {
    window.location.href = path;
  }, []);

  return {
    nav,
    navLegacy,
  };
};
